import { BASE_URL } from "../Config";
import AxiosInstance from "../AxiosInstance";

const PATH = "home/";

const GetChart = () => {
  const url = BASE_URL + PATH + "chart";
  return AxiosInstance.get(url);
};

const Home = {
  GetChart: GetChart,
};

export default Home;
